import request from './request'

export function getArticles(hospId, cate, offset) {
    let params = {
        hospId,
        cate,
        offset,
        limit: 10
    }
    return request.get('/api/article/list', {
        params
    });
}

export function getArticle(hospId, id) {
    return request.get('/api/article/get', {
        params: {
            hospId,
            id
        }
    })
}